<template>
  <div v-if="user" class="header-wrapper">
    <base-button
      v-if="false"
      class="btn search-information-btn mr-3"
      :button="isSyncing ? 'Đang xử lý...' : 'Đồng bộ dữ liệu'"
      @click="syncData"
      :disabled="isSyncing"
    />
    <div class="v-select-app" v-if="false">
      <v-select
        :options="danhSachApp"
        id="id"
        label="name"
        :reduce="(app) => app.id"
        v-model="appId"
        :readonly="true"
        placeholder="Chọn ứng dụng"
      >
        <span slot="no-options"> Không tìm thấy dữ liệu </span></v-select
      >
    </div>
    <b-dropdown class="header-account" menu-class="w-100">
      <template v-slot:button-content>
        <div class="user">
          <img
            :src="`${anhDaiDien_FilePath}`"
            class="avatar"
            v-if="anhDaiDien_FilePath"
            @error="setAltImg"
            alt="image"
          />
          <img
            class="avatar"
            src="@/assets/images/profile.png"
            v-else
            alt="image"
          />
          <div class="userName">{{ user.hoTen || user.userName }}</div>
        </div>
      </template>
      <b-dropdown-item @click="moThongTinNguoiDung()" href="#">
        <b-icon icon="person-fill" />
        <span class="pl-2">Thông tin cá nhân</span>
      </b-dropdown-item>
      <b-dropdown-item @click="moThayDoiMatKhau()" href="#">
        <b-icon icon="lock" />
        <span class="pl-2">Thay đổi mật khẩu</span>
      </b-dropdown-item>
      <b-dropdown-item @click="dangXuat()" href="#">
        <b-icon icon="box-arrow-right" />
        <span class="pl-2">Đăng xuất</span>
      </b-dropdown-item>
      <QuanLyMatKhau ref="thay-doi-mat-khau" @doiMatKhau="thayDoiMatKhau" />
      <b-modal
        :hide-footer="true"
        centered
        id="thong-tin-tai-khoan"
        ref="thong-tin-tai-khoan"
        size="lg"
        title="Thông tin tài khoản"
      >
        <b-row v-if="user">
          <b-col cols="6">
            <BaseUploadImage
              class="p-2"
              :image="anhDaiDien_FilePath"
              :isAcoutUser="true"
              @input="
                upLoadFileToServer(
                  $event,
                  imageType.anhDaiDien,
                  'anhDaiDien_FilePath'
                )
              "
            />
          </b-col>
          <b-col>
            <b-row class="pb-1">
              <b-col cols="5">
                <div>
                  Họ và tên
                </div>
              </b-col>
              <b-col cols="7" class="break-work">
                <div v-if="!isEdit">
                  <div>{{ user.hoTen }}</div>
                  <font-awesome-icon
                    icon="edit"
                    class="pl-1 pt-1"
                    @click="clickEdit"
                  />
                </div>
                <b-form-input
                  v-show="isEdit"
                  id="hoTen"
                  @keyup.enter="SetThongTinHoTen(paramsInputHoTen)"
                  @focusout="focusOutHoten(paramsInputHoTen)"
                  v-model="paramsInputHoTen"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="5">
                <div>
                  Email
                </div>
              </b-col>
              <b-col cols="7" class="break-work">
                <div v-if="!isEditEmail">
                  <span> {{ user.email }} </span>
                  <font-awesome-icon
                    icon="edit"
                    class="pl-1 pt-1"
                    @click="clickEditEmail"
                  />
                </div>
                <validation-observer ref="dwCanBo">
                  <ValidationProvider
                    name="Email"
                    rules="email"
                    v-slot="validationContext"
                  >
                    <div>
                      <b-form-input
                        v-show="isEditEmail"
                        id="email"
                        type="email"
                        :state="getValidationState(validationContext)"
                        @focusout="focusOutEmail(paramsInputEmail)"
                        @keyup.enter="SetThongTinEmail(paramsInputEmail)"
                        v-model="paramsInputEmail"
                      />
                    </div>
                    <b-form-invalid-feedback v-if="isEditEmail"
                      >{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </ValidationProvider>
                </validation-observer>
              </b-col>
            </b-row>
            <b-row :key="key" v-for="(value, key) in THONG_TIN_TAI_KHOAN">
              <b-col cols="5">{{ value }}</b-col>
              <b-col cols="5">{{ user[key] }}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-modal>
    </b-dropdown>
  </div>
</template>
<script>
import { ROUTE_NAME, THONG_TIN_TAI_KHOAN } from "@/constants/constants";
import { mapGetters } from "vuex";
import {
  getValueFromStorageByKey,
  LOCAL_STORAGE_KEY,
  setValueToStorageByKey,
} from "@/utils/localStorage";
import QuanLyMatKhau from "../pages/NguoiDung/QuanLyMatKhau";
import { CAP_NHAT_MAT_KHAU_NGUOI_DUNG_THANH_CONG } from "../../constants/message";
import BaseUploadImage from "@/components/common/BaseUploadImage";

export default {
  name: "BaseHeaderAccount",
  components: { QuanLyMatKhau, BaseUploadImage },
  data() {
    return {
      isLoadingImage: false,
      THONG_TIN_TAI_KHOAN: THONG_TIN_TAI_KHOAN,
      appId: null,
      user: null,
      isSyncing: false,
      showImg: true,
      imageType: {
        anhDaiDien: 1,
      },
      isEdit: false,
      isEditEmail: false,
      anhDaiDien_FilePath: null,
      paramsInputHoTen: "",
      paramsInputEmail: "",
      dataUser: {
        anhChuKyNhay_FilePath: "",
        anhChuKy_FilePath: "",
        anhDaiDien_FilePath: "",
        bit_NhanTinBuon_Email: "",
        bit_NhanTinBuon_SMS: "",
        bit_ThuTruongDonVi: "",
        departments: [],
        email: "",
        gioiTinh: "",
        hoTen: "",
        id: "",
        maCanBoL: "",
        ngaySinh: "",
        thuTu: null,
        userAccounts: [],
        userName: "",
      },
    };
  },
  created() {
    this.layDanhSachApp();
    this.layChiTietCanBo();
    this.appId = getValueFromStorageByKey(LOCAL_STORAGE_KEY.APP_ID);
    this.user = getValueFromStorageByKey(LOCAL_STORAGE_KEY.USER_INFO);
  },
  computed: {
    ...mapGetters({
      //user: "common/userInfo",
      danhSachApp: "app/tatCaApp",
    }),
  },
  watch: {
    appId: {
      handler() {
        setValueToStorageByKey(LOCAL_STORAGE_KEY.APP_ID, this.appId);
        this.$store.dispatch("common/setAppId", this.appId);
      },
    },
  },
  methods: {
    focusOutHoten(data) {
      this.SetThongTinHoTen(data);
      this.isEdit = false;
      this.paramsInputHoTen = "";
    },
    focusOutEmail(data) {
      this.SetThongTinEmail(data);
      this.isEditEmail = false;
      this.paramsInputEmail = "";
    },
    clickEdit() {
      this.isEdit = true;
      setTimeout(() => {
        document.getElementById("hoTen").focus();
      }, 50);
    },
    clickEditEmail() {
      this.isEditEmail = true;
      setTimeout(() => {
        document.getElementById("email").focus();
      }, 50);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    SetThongTinHoTen(data) {
      if (data !== "") {
        const payload = this.dataUser;
        payload.hoTen = data;
        this.updateCanBo(payload);
        this.paramsInputHoTen = "";
        this.isEdit = false;
      } else {
        return;
      }
    },
    async SetThongTinEmail(data) {
      if (data !== "") {
        const isValid = await this.$refs.dwCanBo.validate();
        if (isValid) {
          const payload = this.dataUser;
          payload.email = data;
          this.paramsInputEmail = "";
          this.isEditEmail = false;
          this.updateCanBo(payload);
        }
      }
    },
    async upLoadFileToServer(image, type) {
      let payload = new FormData();
      payload.append("File", image);
      payload.append("ImageType", type);
      payload.append("Id", this.$route.params.id);
      await this.$store
        .dispatch("canBo/upload", {
          data: payload,
        })
        .then((res) => {
          const payload = this.dataUser;
          payload.anhDaiDien_FilePath = res.data.data.filePath;
          this.updateCanBo(payload);
          this.getAnhDaiDien_FilePath(res.data.data.filePath)

        });
    },
    getAnhDaiDien_FilePath(payload) {
      this.$store.dispatch('canBo/getImageUser',{path: payload}).then((res) => {
        this.anhDaiDien_FilePath = this._arrayBufferToBase64(res)
      })
    },
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
      }
      return `data:image/png;base64,${window.btoa( binary )}`
    },
    updateCanBo(payload) {
      this.$store
        .dispatch("canBo/capNhatCanBoNew", {
          data: payload,
        })
        .then(() => {
          this.$store.dispatch("canBo/layThongTinCanBo").then((res) => {
            localStorage.setItem("userInfo", JSON.stringify(res.data.data));
            this.user = res.data.data;
          });
        });
    },
    setAltImg() {
      this.showImg = false;
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    moThongTinNguoiDung() {
      this.$refs["thong-tin-tai-khoan"].show();
    },
    layChiTietCanBo() {
      this.$store.dispatch("canBo/layThongTinCanBo").then((res) => {
        this.dataUser = res.data.data;
        this.getAnhDaiDien_FilePath(res.data.data.anhDaiDien_FilePath)
      });
    },
    moThayDoiMatKhau() {
      this.$refs["thay-doi-mat-khau"].$refs["thay-doi-mat-khau"].show();
    },
    async thayDoiMatKhau() {
      const isValid = await this.$refs[
        "thay-doi-mat-khau"
      ].$refs.observer.validate();
      const $vm = this;
      let matKhauCapNhat = this.$refs["thay-doi-mat-khau"].getInternalForm();
      let payload = {
        userName: this.user.userName,
        passwordOld: matKhauCapNhat.password,
        password: matKhauCapNhat.newPassword,
        repeatPassword: matKhauCapNhat.confirmPassword,
      };
      if (isValid) {
        this.$store
          .dispatch("user/thayDoiMatKhau", payload)
          .then((response) => {
            if (response.status === 200) {
              this.$refs["thay-doi-mat-khau"].hideModal();
              $vm.$toasted.global.showSuccessMessage({
                message: CAP_NHAT_MAT_KHAU_NGUOI_DUNG_THANH_CONG,
              });
            } else if (!response.succeeded) {
              $vm.$toasted.global.showErrorMessage({
                message: response.message,
              });
            }
          })
          .catch((err) => {
            $vm.$toasted.global.showErrorMessage({
              message: "Cập nhật mật khẩu thất bại",
            });
          });
      }
    },
    syncData() {
      this.isSyncing = true;
      this.$store
        .dispatch("common/syncData")
        .then((res) => {
          console.log(res);
          this.$toasted.global.showSuccessMessage({
            message: "Đồng bộ dữ liệu thành công!",
          });
          this.isSyncing = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toasted.global.showErrorMessage({
            message: "Đồng bộ dữ liệu thất bại, vui lòng thử lại!",
          });
          this.isSyncing = false;
        });
    },
    dangXuat() {
      localStorage.removeItem("isLogin");
      this.$store.dispatch("common/setIsLogin", false);
      this.$router.push({
        name: ROUTE_NAME.DANG_NHAP,
      });
    },
  },
};
</script>
<style lang="scss">
.break-work {
  word-break: break-word;
  div {
    display: flex !important;
  }
}
.header-wrapper {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 0;
}
.v-select-app {
  width: 400px;
  // margin-right: 45px;
}
</style>
